import { KEYS } from 'app/constants/SceneConstants';
import SceneBaseTT from './SceneBaseTT';

export default class LevelComplete extends SceneBaseTT {
  constructor() {
    super({ key: KEYS.LevelComplete, active: false });
  }

  init(config) {
    this._config = config.data;
  }

  create() {
    super.create();
    this.setBackgroundImage('background_purple');
    this.game.hud.setState('LEVEL_COMPLETE');

    const panel = this.add.image(this.centerX, this.centerY, 'graphics', 'overlay_panel_blue');
    panel.displayHeight = 415;
    const strip = this.add.image(this.centerX, panel.y - 110, 'graphics', 'overlay_panel_strip');
    strip.displayHeight = 109;
    this.add.image(840, 125, 'locale_text', 'title_levelcomplete');
    this.add.image(840, strip.y, 'locale_text', 'label_nextlevel');
    this.add.image(590, 720, 'character_thumbs', 'char_pose_' + this._config.heroid).setOrigin(1);
    this.add.image(840, panel.y + 110, 'locale_text', 'levelthumb_lvl_' + this._config.nextLevel);

    this.game.soundController.playSFX('sfx', 'arrive_level_win_screen');
    this.game.soundController.playMusic('win');
  }

  shutdown() {
    this.game.hud.resumePreviousState();
    super.shutdown();
  }
}
